import React, { useState } from 'react'
import {
  PrimaryHeaderBranding,
  PrimaryHeaderNavLink,
  StandardProps,
  User,
} from '../../types/common'
import { Branding } from '../Branding'
import { Navbar } from '../Navbar'
import { Nav, NavItem } from '../Navbar/Nav'
import { Sidebar } from '../Sidebar'
import { Toggle } from '../Toggle'
import { UserMenu } from '../UserMenu'

export interface PrimaryHeaderProps extends StandardProps {
  navigationLinks: PrimaryHeaderNavLink[]
  branding: PrimaryHeaderBranding
  loginLink?: React.ReactElement
  user?: User
  userMenuOptions?: React.ReactElement[]
  activeNavItemIndex?: number
}

export function PrimaryHeader(props: PrimaryHeaderProps) {
  const {
    navigationLinks,
    branding,
    loginLink,
    user,
    userMenuOptions,
    activeNavItemIndex,
    className,
    style,
  } = props
  const [isToggled, setIsToggled] = useState(false)

  return (
    <Navbar type='primary' className={className} style={style}>
      <Navbar.Left>
        <Sidebar
          brand={<Branding src={branding.src} alt={branding.alt} />}
          items={
            <Nav>
              {navigationLinks.map((navigationLink, i) => (
                <NavItem
                  key={i}
                  href={navigationLink.href}
                  title={navigationLink.title}
                  isActive={activeNavItemIndex === i}
                />
              ))}
            </Nav>
          }
          isOpen={isToggled}
          onClose={() => setIsToggled((prevToggled) => !prevToggled)}
        />
        <Toggle
          isToggled={isToggled}
          onToggle={() => setIsToggled((prevToggled) => !prevToggled)}
        />
        <Branding src={branding.src} alt={branding.alt} />
      </Navbar.Left>
      <Navbar.Center>
        <Nav>
          {navigationLinks.map((navigationLink, i) => (
            <NavItem
              key={i}
              href={navigationLink.href}
              title={navigationLink.title}
              isActive={activeNavItemIndex === i}
            />
          ))}
        </Nav>
      </Navbar.Center>
      {((user && userMenuOptions) || loginLink) && (
        <Navbar.Right>
          <UserMenu
            user={user}
            options={userMenuOptions}
            loginLink={loginLink}
          />
        </Navbar.Right>
      )}
    </Navbar>
  )
}
